import React, { createContext, useContext, RefObject } from "react";

interface MainScrollContextProps {
  mainRef: RefObject<HTMLElement> | null;
  scrollToTop: () => void;
}

const MainScrollContext = createContext<MainScrollContextProps>({
  mainRef: null,
  scrollToTop: () => {},
});

export const MainScrollProvider: React.FC<{
  children: React.ReactNode;
  mainRef: RefObject<HTMLElement>;
}> = ({ children, mainRef }) => {
  const scrollToTop = () => {
    if (mainRef.current) {
      mainRef.current.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  return (
    <MainScrollContext.Provider
      value={{
        mainRef,
        scrollToTop,
      }}
    >
      {children}
    </MainScrollContext.Provider>
  );
};

export const useMainScroll = () => useContext(MainScrollContext); 